/* @flow */

import React from 'react';
import { Grid, Message, Segment, Button } from 'semantic-ui-react';
import DeployButton from './DeployButton';

type Props = {
  onDeployed: () => void,
};

const NoDeployments = ({ onDeployed }: Props) => (
  <Segment>
    <Grid centered columns={2}>
      <Grid.Column textAlign="center">
        <Message
          attached
          header={`Aucun déploiement actuellement en production`}
          content={`L'application est pour le moment inaccessible aux utilisateurs mobiles`}
        />
        <Segment attached="bottom">
          <DeployButton
            onDeployed={onDeployed}
            children={onClick => (
              <Button
                onClick={onClick}
                icon="space shuttle"
                color="red"
                labelPosition="left"
                size="big"
                content="Déployer en production"
              />
            )}
          />
        </Segment>
      </Grid.Column>
    </Grid>
  </Segment>
);

export default NoDeployments;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Deployments/components/NoDeployments.js